module.exports = __webpack_public_path__ + "img/5124359.jpg";